export const RegistrationSource = {
  Wizard: 'WIZARD',
  B2BForm: 'B2B_FORM',
  Form: 'FORM',
  Catalog: 'CATALOG'
}
